import { AppDispatch } from "../../../app/store";
import storage from "../../../utils/store/storage";
import { REMEMBER_ME } from "../../../utils/store/storeVariables";
import { setRememberMe as setRememberMeAction } from "../sessionSlice";

export function setRememberMe(dispatch: AppDispatch, rememberMe: boolean) {
  storage.saveItem(REMEMBER_ME, rememberMe, rememberMe);
  dispatch(setRememberMeAction(rememberMe));
}
